<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/r6qzkG/tc-custom/9781466841758.jpg?1737771000990" alt="This image is the cover for the book Lady Robyn, War of the Roses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady Robyn, War of the Roses
      </h1>
      <p class="bookDescription body article font2">
        <p>The author of two highly praised novels,<i> The Spiral Dance </i>and <i>American Woman</i>, R. Garcia y Robertson returns with a charming time-travel romance sequence. In <i>Knight Errant</i>, Robyn Stafford, a young American woman hiking in England near the Welsh border, was swept back in time to the 1460s, the age of the War of the Roses. There she fell in love with a young knight, Edward, son of the Duke of York. Cast back in time by witchcraft, Robyn, a young executive from Hollywood, raised in Montana, has chosen to stay there out of love for Edward, who has promised to marry her.<br/><br/>Now in <i>Lady Robyn</i>, Robyn's fantasy of courtly romance comes up against the brute reality of medieval politics: the politics of murder, warfare, and betrayal. The War of the Roses is no longer a textbook subject, it's messing up her life, and so is the noble witch who, though he doesn't know it, is Edward's enemy. Edward's father, Richard, is making a bid for the throne, and if he wins it, Edward will be heir apparent. And if Robyn marries him, she will someday be queen and her children heirs to the throne as well. In the 1460s, that means living with the constant threat of death. The survival rate for heirs is not high. Will Robyn reject her love or risk the lives of her children to be?<br/><br/>This is an engrossing time-travel romance in the mold of Diana Gabaldon's bestselling timeslip tales.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. Garcia y Robertson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?222d7f01